<div class="custom-tab-wrapper my-4">
  <div class="custom-tab-buttons">
    <button [ngClass]="{ active: selectedTab === 0 }" (click)="selectedTab = 0">
      Unprocessed
    </button>
    <button [ngClass]="{ active: selectedTab === 1 }" (click)="selectedTab = 1">
      Processed
    </button>
  </div>

  <div class="custom-tab-content">
    <ng-container [ngSwitch]="selectedTab">
      <duplicate-app-unprocessed *ngSwitchCase="0"></duplicate-app-unprocessed>
      <duplicate-app-processed *ngSwitchCase="1"></duplicate-app-processed>
    </ng-container>
  </div>
</div>
